import { Edit, useEditContext, useRecordContext, useTranslate } from 'react-admin';
import { ProductForm } from './ProductForm';

const ProductEditTitle = () => {
    const translate = useTranslate();
    const record = useRecordContext();
    if (!record) return null;
    return <span>
      {translate(`resources.productvariants.name`, { smart_count: 1 })}{' '}
      {record.name} - {record.variant}
      </span>;
};

export const ProductEdit = (props: any) => {
  return (
  <Edit {...props} title={<ProductEditTitle/>}>
    <ProductForm  edit={true} />
  </Edit>
)};
